import { render, staticRenderFns } from "./detailsTopTip.vue?vue&type=template&id=d59f3c3c&"
import script from "./detailsTopTip.vue?vue&type=script&lang=js&"
export * from "./detailsTopTip.vue?vue&type=script&lang=js&"
import style0 from "./detailsTopTip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports